console.log("Maxilite Global: ");


function clearDataSpecsTable() {
  console.log("Cleaning Data");
  let rows = document.querySelectorAll('#product-specs-table tr[id]');
  rows.forEach(row => {
    row.innerHTML = '';
    row.style.display = 'none';
  });
}


//New Function update_specs
async function assingSpecsData() {
//Changing the whay we handle variables in this function
//Changing the specs_data and variant id to get handle inside this current function


//Moving the the getter from specs_data to the metafieldData
const metafieldData = await getMetafieldData();
const { currentVariant, sectionId } = await getProductPageAttributes();

  const current_variantID = currentVariant;
  console.log("Variant ID: ", current_variantID);

 console.log("Assigning Specs Data: ");


  const skuObject = getSkuData();
  const sku = skuObject;
  const {
    finish,
    shade,
    glass,
    replacement_glass,
    variant_description: desc,
    dimming_percentage: dim_percentage,
    type_of_dimmer: dim_type,
    cri,
    optional_cri: optCri,
    lamping,
    led_life,
    "24_7_led_life": led_life24,
    color_temp,
    color_temp_option,
    width,
    height,
    length,
    max_width,
    max_height,
    max_length,
    width_mm,
    height_mm,
    length_mm,
    max_width_mm,
    max_height_mm,
    max_length_mm,
    suspension,
    extension,
    max_extension,
    canopy_width,
    canopy_height,
    canopy_length,
    canopy_diameter,
    wattage,
    delivered_lumens,
    included_count: incl_count,
    included_desc: incl_desc,
    required_count: req_count,
    required_desc: req_desc,
    required_shape: req_shape,
    location: loc,
    warranty,
    certification,
    voltage,
    optional_voltage: opt_voltage,
    made_in_canada,
    download1_name,
    download1_url,
    download2_name,
    download2_url,
    download3_name,
    download3_url,
    download4_name,
    download4_url,
    availability,
    special_instructions,
    hasQuickShip: hasQuickShipment,
    quick_ship_qty: quickShopStock,
    ship_time: hasQuickShipTime,
  } = metafieldData;

  //console.log("Object destructuring complete");
  //console.log(finish);

 // console.log("Updating specs");

  //Getting Metafield Data:

  // console.log("Metafield Data:", metafieldData);

//  const { imageUrl, hasFeatureImage } = getFeaturedImage();
  //console.log("Featured Image: ", imageUrl);
  //console.log("Has Featured Image: ", hasFeatureImage);

  //QuickShipCode

//   //console.log("--------QuickShip Info ----- " + hasQuickShipment);
//   if (hasQuickShipment === "true") {
//     // console.log("This product has quickshipment " + hasQuickShipment);
//     if (quickShopStock) {
//       document.getElementById("maxi-StockShip").textContent = quickShopStock;
//       // console.log("Stock:" + quickShopStock);
//     } else {
//       document.getElementById("maxi-StockShip").textContent =
//         "Info unavailable. Please contact us for exact quantity info";
//       // console.log("Stock:" + quickShopStock);
//     }

//     if (hasQuickShipTime == null || hasQuickShipTime === "Contact us") {
//       //  console.log("Quick-Ship Time is:" + hasQuickShipTime);
//       document.getElementById("maxi-timeShiping").textContent =
//         "Contact us – This configuration will take longer to ship; we will provide a shipping date shortly. Select another option for next day shipping.";
//     } else {
//       document.getElementById("maxi-timeShiping").textContent =
//         hasQuickShipTime;
//       // console.log("Quick-Ship Time is:" + hasQuickShipTime);
//     }
//     document.getElementById("quick-maxi").style.display = "block";
//   } else {
//     // console.log("No Quickshipment Found ");
//     document.getElementById("quick-maxi").style.display = "none";
//   }

  // update main specs table
  if (sku != null) {
    document.getElementById("row-sku").innerHTML =
      "<td>Part Number</td><td>" + sku + "</td>";
    document.getElementById("row-sku").style.display = "table-row";
  } else {
    document.getElementById("row-sku").style.display = "none";
  }
  if (desc != null) {
    document.getElementById("container-desc").innerHTML = desc;
  } else {
    document.getElementById("container-desc").innerHTML = "";
  }
  if (made_in_canada != null) {
    document.getElementById("row-made-in-canada").innerHTML =
      "<td>Made in Canada</td><td>" + made_in_canada + "</td>";
    document.getElementById("row-made-in-canada").style.display = "table-row";
  } else {
    document.getElementById("row-finish").style.display = "none";
  }
  if (finish != null) {
    document.getElementById("row-finish").innerHTML =
      "<td>Finish</td><td>" + finish + "</td>";
    document.getElementById("row-finish").style.display = "table-row";
  } else {
    document.getElementById("row-finish").style.display = "none";
  }
  if (shade != null) {
    document.getElementById("row-shade").innerHTML =
      "<td>Shade</td><td>" + shade + "</td>";
    document.getElementById("row-shade").style.display = "table-row";
  } else {
    document.getElementById("row-shade").style.display = "none";
  }
  if (glass != null) {
    document.getElementById("row-glass").innerHTML =
      "<td>Glass</td><td>" + glass + "</td>";
    document.getElementById("row-glass").style.display = "table-row";
  } else {
    document.getElementById("row-glass").style.display = "none";
  }
  if (replacement_glass != null) {
    document.getElementById("row-replacement-glass").innerHTML =
      "<td>Replacement Glass</td><td>" + replacement_glass + "</td>";
    document.getElementById("row-replacement-glass").style.display =
      "table-row";
  } else {
    document.getElementById("row-replacement-glass").style.display = "none";
  }

  // dimensions
  var dimensions = [];
  if (width_mm != null) {
    if (width_mm != null) {
      dimensions.push("W" + width_mm + "mm");
    }
    if (height_mm != null) {
      dimensions.push("H" + height_mm + "mm");
    }
    if (length_mm != null) {
      dimensions.push("L" + length_mm + "mm");
    }
  } else {
    if (width != null) {
      dimensions.push("W" + width + "&Prime;");
    }
    if (height != null) {
      dimensions.push("H" + height + "&Prime;");
    }
    if (length != null) {
      dimensions.push("L" + length + "&Prime;");
    }
    if (extension != null) {
      dimensions.push("E" + extension + "&Prime;");
    }
  }

  if (dimensions.length > 0) {
    //if any dimensions exist in the array
    document.getElementById("row-dimensions").innerHTML =
      "<td>Dimensions</td><td>" + dimensions.join(" X ") + "</td>";
    document.getElementById("row-dimensions").style.display = "table-row";
  } else {
    document.getElementById("row-dimensions").style.display = "none";
  }

  // max dimensions
  var max_dimensions = [];
  if (max_width_mm != null) {
    if (max_width_mm != null) {
      max_dimensions.push("W" + max_width_mm + "mm");
    }
    if (max_height_mm != null) {
      max_dimensions.push("H" + max_height_mm + "mm");
    }
    if (max_length_mm != null) {
      max_dimensions.push("L" + max_length_mm + "mm");
    }
  } else {
    if (max_width != null) {
      max_dimensions.push("W" + max_width + "&Prime;");
    }
    if (max_height != null) {
      max_dimensions.push("H" + max_height + "&Prime;");
    }
    if (max_length != null) {
      max_dimensions.push("L" + max_length + "&Prime;");
    }
    if (max_extension != null) {
      max_dimensions.push("E" + max_extension + "&Prime;");
    }
  }

  if (max_dimensions.length > 0) {
    //if ALL dimensions existcanopy_diameter
    document.getElementById("row-max-dimensions").innerHTML =
      "<td>Maximum Dimensions</td><td>" + max_dimensions.join(" X ") + "</td>";
    document.getElementById("row-max-dimensions").style.display = "table-row";
  } else {
    document.getElementById("row-max-dimensions").style.display = "none";
  }
  //Product url testing
  //https://maxilite.lighting/products/bar-36?variant=42265318162686

  //Canopy Dimentions

  const canopyDimentions = [];
  if (canopy_width != null) {
    if (canopy_width != null) {
      canopyDimentions.push("W" + canopy_width + "&Prime;");
    }
    if (canopy_height != null) {
      canopyDimentions.push("H" + canopy_height + "&Prime;");
    }
    if (canopy_length != null) {
      canopyDimentions.push("L" + canopy_length + "&Prime;");
    }
  }

  if (canopyDimentions.length > 0) {
    document.getElementById("row-canopy-dimensions").innerHTML =
      "<td>Canopy Dimensions</td><td>" + canopyDimentions.join(" X ") + "</td>";
    document.getElementById("row-canopy-dimensions").style.display =
      "table-row";
  } else {
    document.getElementById("row-canopy-dimensions").style.display = "none";
  }

  //Canopy Diameter
 // console.log("Product Description:",desc);
  //console.log("CanopyDiameter: ", canopy_diameter);
  if (canopy_diameter != null) {
    document.getElementById(
      "row-canopy-diameter"
    ).innerHTML = `<td>Canopy Diameter</td><td>${canopy_diameter}&Prime;</td>`;
    document.getElementById("row-canopy-diameter").style.display = "table-row";
  } else {
    document.getElementById("row-canopy-diameter").style.display = "none";
  }

  // suspension
  if (suspension != null) {
    document.getElementById("row-suspension").innerHTML =
      "<td>Suspension</td><td>" + suspension + "</td>";
    document.getElementById("row-suspension").style.display = "table-row";
  } else {
    document.getElementById("row-suspension").style.display = "none";
  }

  if (wattage != null) {
    // just display the wattage number by itself
    document.getElementById("row-wattage").innerHTML =
      "<td>Wattage</td><td>" + Math.trunc(wattage) + "</td>";
  } else {
    // if wattage data does not exist
    document.getElementById("row-wattage").style.display = "none";
  }

  if (certification != null) {
    document.getElementById("row-certification").innerHTML =
      "<td>Certification</td><td>" + certification + "</td>";
    document.getElementById("row-certification").style.display = "table-row";
  } else {
    document.getElementById("row-certification").style.display = "none";
  }
  if (delivered_lumens != null) {
    document.getElementById("row-delivered-lumens").innerHTML =
      "<td>Delivered Lumens</td><td>" + Math.trunc(delivered_lumens) + "</td>";
    document.getElementById("row-delivered-lumens").style.display = "table-row";
  } else {
    document.getElementById("row-delivered-lumens").style.display = "none";
  }

  //Disclaimer
  //If the product `Handle`|sku begins with MXA, MXD, or MXL, show this disclaimer
  if (sku.startsWith("MXA") || sku.startsWith("MXD") || sku.startsWith("MXL")) {
    document.getElementById("row-disclaimer").innerHTML =
      "<td></td><td>Disclaimer: Delivered Lumens are based on calculations – Please contact factory for IES Files if required.</td>";
    document.getElementById("row-disclaimer").style.display = "table-row";
  } else {
    document.getElementById("row-disclaimer").style.display = "none";
  }

  //DIMMING
  if (dim_percentage != null || lamping == "Incandescent") {
    //if there's a dim percentage OR incandescent
    document.getElementById("row-dimmable").innerHTML =
      "<td>Dimmable</td><td>Yes</td>";
  } else {
    document.getElementById("row-dimmable").innerHTML =
      "<td>Dimmable</td><td>No</td>";
  }
  if (dim_percentage != null) {
    //if there's a dim percentage
    document.getElementById("row-dim-percentage").innerHTML =
      "<tr><td>Dimming Percentage</td><td>" + dim_percentage + "</td></tr>";
    document.getElementById("row-dim-percentage").style.display = "table-row";
  } else {
    document.getElementById("row-dim-percentage").style.display = "none";
  }
  if (dim_type != null) {
    //if there's a dim type
    document.getElementById("row-dim-type").innerHTML =
      "<tr><td>Type of Dimmer</td><td>" + dim_type + "</td></tr>";
    document.getElementById("row-dim-type").style.display = "table-row";
  } else {
    document.getElementById("row-dim-type").style.display = "none";
  }
  if (cri != null) {
    document.getElementById("row-cri").innerHTML =
      "<td>CRI</td><td>" + cri + "</td>";
    document.getElementById("row-cri").style.display = "table-row";
  } else {
    document.getElementById("row-cri").style.display = "none";
  }
  if (optCri != null) {
    document.getElementById("row-optcri").innerHTML =
      "<td>Optional CRI</td><td>" + optCri + "</td>";
    document.getElementById("row-optcri").style.display = "table-row";
  } else {
    document.getElementById("row-cri").style.display = "none";
  }
  if (led_life != null) {
    document.getElementById("row-led-life").innerHTML =
      "<td>LED Life</td><td>" + led_life + "</td>";
    document.getElementById("row-led-life").style.display = "table-row";
  } else {
    document.getElementById("row-led-life").style.display = "none";
  }
  if (led_life24 != null) {
    document.getElementById("row-24led-life").innerHTML =
      "<td>24/7 LED Life</td><td>" + led_life24 + "</td>";
    document.getElementById("row-24led-life").style.display = "table-row";
  } else {
    document.getElementById("row-24led-life").style.display = "none";
  }

  if (color_temp != null) {
    document.getElementById("row-color-temp").innerHTML =
      "<td>Color Temperature</td><td>" + Math.trunc(color_temp) + "</td>";
    document.getElementById("row-color-temp").style.display = "table-row";
  } else {
    document.getElementById("row-color-temp").style.display = "none";
  }
  if (color_temp_option != null) {
    document.getElementById("row-color-temp-option").innerHTML =
      "<td>Color Temperature Options</td><td>" + color_temp_option + "</td>";
    document.getElementById("row-color-temp-option").style.display =
      "table-row";
  } else {
    document.getElementById("row-color-temp-option").style.display = "none";
  }
  if (loc != null) {
    document.getElementById("row-location").innerHTML =
      "<td>Location</td><td>" + loc + "</td>";
    document.getElementById("row-location").style.display = "table-row";
  } else {
    document.getElementById("row-location").style.display = "none";
  }
  if (warranty != null) {
    document.getElementById("row-warranty").innerHTML =
      "<td>Warranty</td><td>" + warranty + "</td>";
    document.getElementById("row-warranty").style.display = "table-row";
  } else {
    document.getElementById("row-warranty").style.display = "none";
  }
  if (incl_count != null) {
    // if bulbs included
    document.getElementById("row-bulbs-included").innerHTML =
      "<td>Bulbs Included</td><td>" + incl_count + " X " + incl_desc + "</td>";
    document.getElementById("row-bulbs-included").style.display = "table-row";
    document.getElementById("row-bulbs-required").style.display = "none";
  } else if (req_count != null) {
    // if bulbs ARE NOT included
    document.getElementById("row-bulbs-included").innerHTML =
      "<td>Bulbs Included</td><td>None</td>";
    document.getElementById("row-bulbs-required").innerHTML =
      "<td>Bulbs Required</td><td>" +
      req_count +
      " X " +
      req_desc +
      " " +
      req_shape +
      "</td>";
    document.getElementById("row-bulbs-included").style.display = "table-row";
    document.getElementById("row-bulbs-required").style.display = "table-row";
  } else {
    // if neither incl NOR req information exists
    document.getElementById("row-bulbs-included").style.display = "none";
    document.getElementById("row-bulbs-required").style.display = "none";
  }
  if (certification != null) {
    document.getElementById("row-certification").innerHTML =
      "<td>Certification</td><td>" + certification + "</td>";
    document.getElementById("row-certification").style.display = "table-row";
  } else {
  }
  if (voltage != null) {
    document.getElementById("row-voltage").innerHTML =
      "<td>Voltage</td><td>" + String(voltage) + "</td>";
    document.getElementById("row-voltage").style.display = "table-row";
  } else {
    document.getElementById("row-voltage").style.display = "none";
  }
  if (opt_voltage != null) {
    document.getElementById("row-opt-voltage").innerHTML =
      "<td>Optional voltage</td><td>" + String(opt_voltage) + "</td>";
    document.getElementById("row-opt-voltage").style.display = "table-row";
  } else {
    document.getElementById("row-opt-voltage").style.display = "none";
  }

  if (special_instructions != null) {
    document.getElementById("special-instructions").innerHTML =
      "<h2 class='specs-table-heading'>Special Instructions</h2><p>" +
      special_instructions +
      "</p>";
    document.getElementById("special-instructions").style.display = "block";
  } else {
    document.getElementById("special-instructions").style.display = "none";
  }

  // //    Download 1 is always the _instructions.pdf file.
  // console.log("Download Url: ", download1_url); //https://maxilitelighting.com/instructions/mxa6318-02-instructions.pdf
  // if (download1_url != null) {
  //   var myRequest = new Request(download1_url);

  //   fetch(myRequest, { redirect: "manual" }).then(function (response) {
  //     if (response.status == 200) {
  //       document.getElementById("container-download1").innerHTML =
  //         "<a href='" +
  //         download1_url +
  //         "' target='_blank'>" +
  //         download1_name +
  //         "</a>";
  //       document.getElementById("container-download1").style.display = "block";
  //       console.log("url for download1_url exists");
  //     } else {
  //       document.getElementById("container-download1").style.display = "none";
  //       console.log("download1 url doesnt exist");
  //     }
  //   });
  // } else {
  //   document.getElementById("container-download1").style.display = "none";
  //   console.log("download1 url doesnt exist");
  // }

  async function fetchDownloadUrl() {
    console.log("Download Url: ", download1_url);
   // Testing url: const newUrl = "//maxilite-manufacturing-ltd-2.myshopify.com/cdn/shop/files/mx-3382-40-instructions.pdf?v=134673462530664668"
  
    if (download1_url != null) {
      try {
        const response = await fetch('https://maxilite-proxy-server.onrender.com/proxy', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            url: download1_url,
            method: 'GET'
          })
        });
        const responseData = await response.json();
        console.log("RESPONSE: ", responseData);
  
        if (response.ok) {
          document.getElementById("container-download1").innerHTML =
            `<a href='${download1_url}' target='_blank'>${download1_name}</a>`;
          document.getElementById("container-download1").style.display = "block";
          console.log("url for download1_url exists");
        } else {
          document.getElementById("container-download1").style.display = "none";
          console.log("download1 url doesn't exist");
        }
      } catch (error) {
        console.error("An error occurred while fetching the URL", error);
      }
    } else {
      document.getElementById("container-download1").style.display = "none";
      console.log("download1 url doesn't exist");
    }


  }
  
  // fetchDownloadUrl();
  


  //reminder: only download1 needs an http request to check if url is valid, because
  //from Excelify spreadsheet these are full URLs.
  //for download2 and download3, all you need is to check if it's null because in
  //the Excelify spreadsheet, these one's will be BLANK.
  // if (download2_url != null) {
  //   document.getElementById("container-download2").innerHTML =
  //     "<a href='https://host.maxilite.lighting/assets/extra_files/" +
  //     download2_url +
  //     "' target='_blank'>" +
  //     download2_name +
  //     "</a>";
  //   document.getElementById("container-download2").style.display = "block";
  // } else {
  //   document.getElementById("container-download2").style.display = "none";
  // }
  // if (download3_url != null) {
  //   document.getElementById("container-download3").innerHTML =
  //     "<a href='https://host.maxilite.lighting/assets/extra_files/" +
  //     download3_url +
  //     "' target='_blank'>" +
  //     download3_name +
  //     "</a>";
  //   document.getElementById("container-download3").style.display = "block";
  // } else {
  //   document.getElementById("container-download3").style.display = "none";
  // }
  // if (download4_url != null) {
  //   document.getElementById("container-download4").innerHTML =
  //     "<a href='https://host.maxilite.lighting/assets/extra_files/" +
  //     download4_url +
  //     "' target='_blank'>" +
  //     download4_name +
  //     "</a>";
  //   document.getElementById("container-download4").style.display = "block";
  // } else {
  //   document.getElementById("container-download4").style.display = "none";
  // }

  
}




//update_quoteform
function update_quoteform() {
  const cv_specs = getMetafieldData();
  // This function only happens once when the user clicks on the
  // request quote button. This avoids any of their work being
  // erased upon changing variant options!
  const sku = getSkuData();
  const { variant_description: desc } = cv_specs;
 // console.log("update_quoteform sku: ", sku);
//  console.log("update_quoteform desc: ", desc);
  // update data in contact form
  if (sku != null && desc != null) {
    document.getElementById("textarea-itemnumbers").innerHTML =
      sku + " (" + desc + ")";
  } else {
    document.getElementById("textarea-itemnumbers").innerHTML = "";
  }
}

//cv_specs
 async function generatePDF() {
  console.log("Generating PDF");
  const cv_specs = getMetafieldData();

  //Complementary functions
  //Function to extracy data from html table specs
  async function extractTableData(sectionClass, hasDisclaimer) {
    var rows = document.querySelectorAll(
      `#product-specs-table .${sectionClass}`
    );
    var data = [];

    rows.forEach(function (row, index) {
      var cells = row.querySelectorAll("td");
    //console.log("Extracting Data form class:", sectionClass);
   // console.log(cells);
      if (cells.length === 2) {
        if (cells[0].textContent !== "") {
          var rowData = {
            key: cells[0].textContent,
            value: cells[1].textContent,
          };
          data.push(rowData);
        }
      }

      // Check if this is the last iteration
      if (index === rows.length - 1) {
       // console.log("This is the last iteration");
        if (sectionClass == "row_section_2" && hasDisclaimer) {
          // Do something specific for the last iteration, if necessary
          var rowData = {
            key: "disclaimer",
            value:
              "Disclaimer:  Delivered Lumens are based on calculations – Please contact factory for IES Files if required.",
          };
          data.push(rowData);
        }
      }
    });

    return data;
  }

  //Function to Fetch the given image and return it as a promise image file
  async function requestImage(imageUrl) {
    console.log("requestImage.imageUrl: " + imageUrl);

    try {
      const response = await fetch(imageUrl);
      if (!response.ok) {
        throw new Error("Network response was not ok " + response.statusText);
      }
      const blob = await response.blob();
      const img = await createImageBitmap(blob);

      return img;
    } catch (error) {
      console.error(
        "There has been a problem with your fetch operation:",
        error
      );
    }
  }
  try {
  const dataMetafields = cv_specs;
  const sku = getSkuData();
  const productPdfSku = sku;

  ////If the product `Handle`|sku begins with MXA, MXD, or MXL, show this disclaimer
  const hasDisclaimer =
    sku.startsWith("MXA") || sku.startsWith("MXD") || sku.startsWith("MXL")
      ? true
      : undefined;

  const section1Data = await extractTableData("row_section_1");
 // console.log(section1Data);
  const section2Data = await extractTableData("row_section_2", hasDisclaimer);
 // console.log(section2Data);
  const section3Data = await extractTableData("row_section_3");
 // console.log(section3Data);
  const section4Data = await extractTableData("row_section_4");
 // console.log(section4Data);
  const section5Data = await extractTableData("row_section_5");
  const section6Data = await extractTableData("row_section_6");
  const section7Data = await extractTableData("row_section_7");

  const canvas = document.getElementById("s1-canvas");
  const { imageUrl, hasFeatureImage } = getFeaturedImage();

  
    const doc = new window.jspdf.jsPDF({ lineHeight: 1.5 });
    const image = await requestImage(imageUrl);

    const ctx = canvas.getContext("2d");
    canvas.width = image.width;
    canvas.height = image.height;
    ctx.drawImage(image, 0, 0);
    //title
    doc.setFont("helvetica", "bold");
    doc.setFontSize(30);
    //old "MAXILITE", 15, 25); 
    doc.text("MAXILITE", 15, 20); //new height position
    doc.setFont("helvetica", "normal");
    doc.setFontSize(14);

    //Adding image to pdf
    var imgScaleRatio = image.width / 100;
    var newImgW = 100;
    var newImgH = image.height / imgScaleRatio;
    //if img height is over 100, make it 100
    //and scale the width accordingly
    if (newImgH > 100) {
      imgScaleRatio = newImgH / 100;
      newImgH = 100;
      newImgW = newImgW / imgScaleRatio;
    }
    doc.addImage(
      canvas.toDataURL("image/png"),
      "PNG",
      110,
      45,
      newImgW,
      newImgH
    );

    //image disclaimer
    doc.setFontSize(8);
    if (hasFeatureImage) {
      doc.text(
        "NOTE: Image may not reflect selected features.",
        130,
        newImgH + 45
      );
    }

    let pdf_sku;
    let pdf_desc;
    if (dataMetafields.variant_description) {
      pdf_desc = dataMetafields.variant_description;
    } else {
      pdf_sku = "Information not available";
    }

    //print text
    doc.setFontSize(10);
    let couterLine = 35;

    //old value doc.text(pdf_desc, 15, 35,
    doc.text(pdf_desc, 15, 30, { maxWidth: 180 });
    couterLine += 15;

   // console.log("Counter line: ", couterLine);
    section1Data.forEach(function (item, index) {
     // console.log("Key: " + item.key + ", Value: " + item.value);
      doc.setFont("helvetica", "bold");
      doc.text(item.key + ":", 15, couterLine, { maxWidth: 180 });
      doc.setFont("helvetica", "normal");
      let itemData = String(item.value).replace(/″/g, '"');
    //  console.log(typeof itemData);
      doc.text(itemData, 57, couterLine);
      couterLine += 6;
    });
   // console.log("Counter line: ", couterLine);
    couterLine += 3;
    section2Data.forEach(function (item) {
      //console.log("Counter line: ", couterLine);
      if (item.key == "disclaimer" && hasDisclaimer) {
       // console.log("Key: " + item.key + ", Value: " + item.value);
        // doc.setFont('helvetica', 'bold');
        // doc.text(item.key, 15, couterLine, { maxWidth: 180 });
        doc.setFont("helvetica", "normal");
        let itemData = String(item.value).replace(/″/g, '"');
       // console.log(typeof itemData);
       //modified the disclaimer to expan all the way
        doc.text(itemData, 15, couterLine, { maxWidth: 100 });
        couterLine += 13;
      } else {
       // console.log("Key: " + item.key + ", Value: " + item.value);
        doc.setFont("helvetica", "bold");
        doc.text(item.key + ":", 15, couterLine, { maxWidth: 180 });
        doc.setFont("helvetica", "normal");
        let itemData = String(item.value).replace(/″/g, '"');
       // console.log(typeof itemData);
        doc.text(itemData, 57, couterLine);
        couterLine += 6;
      }
    });

    if (section3Data.length !== 0) {
      couterLine += 3;
    //  console.log("Counter line: ", couterLine);
      section3Data.forEach(function (item, index) {
      //  console.log("Key: " + item.key + ", Value: " + item.value);
        doc.setFont("helvetica", "bold");
        doc.text(item.key + ":", 15, couterLine, { maxWidth: 180 });
        doc.setFont("helvetica", "normal");
        let itemData = String(item.value).replace(/″/g, '"');
       // console.log(typeof itemData);
        doc.text(itemData, 57, couterLine);
        couterLine += 6;
      });
    }

   // couterLine += 3;
    //doc.text("Color Temperature Options librax:", 15, couterLine, { maxWidth: 30 ,lineHeightFactor: 1 });
 

    if (section4Data.length !== 0) {
      couterLine += 3;
     // console.log("Counter line: ", couterLine);
      section4Data.forEach(function (item, index) {
      //  console.log("Key: " + item.key + ", Value: " + item.value);
        doc.setFont("helvetica", "bold");
       // console.log("SECTION: ", item.key);
       // console.log("String length: ", item.key.length);
        if(item.key.length >= 20){
          doc.text(item.key + ":", 15, couterLine, { maxWidth: 40 ,lineHeightFactor: 1.2 });
        }else{
         doc.text(item.key + ":", 15, couterLine, { maxWidth: 180 });
        }
        doc.setFont("helvetica", "normal");
        let itemData = String(item.value).replace(/″/g, '"');
      //  console.log(typeof itemData);
        doc.text(itemData, 57, couterLine);
        couterLine += 6;
        if(item.key.length >= 20){
          couterLine += 5;
        }
      });
    }

    if (section5Data.length !== 0) {
      couterLine += 3;
    //  console.log("Counter line: ", couterLine);
      section5Data.forEach(function (item, index) {
     //   console.log("Key: " + item.key + ", Value: " + item.value);
        doc.setFont("helvetica", "bold");
        doc.text(item.key + ":", 15, couterLine, { maxWidth: 180 });
        doc.setFont("helvetica", "normal");
        let itemData = String(item.value).replace(/″/g, '"');
     //   console.log(typeof itemData);
        doc.text(itemData, 57, couterLine);
        couterLine += 6;
      });
    }

    if (section6Data.length !== 0) {
      couterLine += 3;
     // console.log("Counter line: ", couterLine);
      section6Data.forEach(function (item, index) {
       // console.log("Key: " + item.key + ", Value: " + item.value);
        doc.setFont("helvetica", "bold");
        doc.text(item.key + ":", 15, couterLine, { maxWidth: 180 });
        doc.setFont("helvetica", "normal");
        let itemData = String(item.value).replace(/″/g, '"');
      //  console.log(typeof itemData);
        doc.text(itemData, 57, couterLine);
        couterLine += 6;
      });
    }
    if (section7Data.length !== 0) {
      couterLine += 3;
    //  console.log("Counter line: ", couterLine);
      section7Data.forEach(function (item, index) {
       // console.log("Key: " + item.key + ", Value: " + item.value);
        doc.setFont("helvetica", "bold");
        doc.text(item.key + ":", 15, couterLine, { maxWidth: 180 });
        doc.setFont("helvetica", "normal");
        let itemData = String(item.value).replace(/″/g, '"');
       // console.log(typeof itemData);
        doc.text(itemData, 57, couterLine);
        couterLine += 6;
      });
    }

//    console.log("Specs info ended in line: ", couterLine);

    //Initial values for the layout of the table
    const startingPositionY = 223; 
    const tableHeight = 60;
    const buttomPositionY = startingPositionY + tableHeight; 

    //left side Values
    const leftSideHeadingSpace = startingPositionY + 6;

    // rigthSide values
    const rightCells_VerticalSpacing = 10; //The space between the rigt side cells
    
    

    //line function arguments
    //doc.line(x1:start , y1:start ,x2: end, y2: end, style);
    //draw table: horizontal lines
    //      (x1,  y1 , x2, y1)
    doc.line(15, startingPositionY, 195, startingPositionY); //top edge
    doc.line(15, leftSideHeadingSpace, 105, leftSideHeadingSpace); //underneath headers
    doc.line(15, buttomPositionY, 195, buttomPositionY); //bottom edge

    //smaller cells on right side
    function drawHorzontalLines(number_position){
      const positionY = startingPositionY + rightCells_VerticalSpacing * number_position;
      return positionY;
    }
 
    doc.line(105, drawHorzontalLines(1), 195, drawHorzontalLines(1));
    doc.line(105, drawHorzontalLines(2), 195, drawHorzontalLines(2));
    doc.line(105, drawHorzontalLines(3), 195, drawHorzontalLines(3));
    doc.line(105, drawHorzontalLines(4), 195, drawHorzontalLines(4));
    doc.line(105, drawHorzontalLines(5), 195, drawHorzontalLines(5));

    //draw table: vertical lines
    doc.line(15, startingPositionY, 15, buttomPositionY); //edge
    doc.line(45, startingPositionY, 45, buttomPositionY); //ref
    doc.line(65, startingPositionY, 65, buttomPositionY); //quantity
    doc.line(105, startingPositionY, 105, buttomPositionY); //remarks
    doc.line(195, startingPositionY, 195, buttomPositionY); //edge

    //table text
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");

    //doc tex( x , y , options);
    
// 220 - 216 = 4 we got 4 of diference in relation to the older value

// Heading text
    const textHeadingPositionY = startingPositionY + 4;
    doc.text("Reference", 17, textHeadingPositionY);
    doc.text("Quantity", 47, textHeadingPositionY);
    doc.text("Remarks", 67, textHeadingPositionY);
    doc.text("Project", 107, textHeadingPositionY);

  // rigth side text 
  // we could use the same logic as the other thigs 
  //it may work if we can figure out because it goes 10 by 10 
  // 230 - 216
  // initial-y + 14
  const textR_SideStart = startingPositionY + 14;

  function getTextSideY(num_position){
    const textPosition = textR_SideStart + num_position;
    return textPosition;
  }

    doc.text("Location/Type", 107, textR_SideStart);
    doc.text("Architect", 107, getTextSideY(10));
    doc.text("Engineer", 107, getTextSideY(20));
    doc.text("Contractor", 107, getTextSideY(30));
    doc.text("Submitted by:", 107, getTextSideY(40));
    doc.text("Date:", 160, getTextSideY(40));

    //footer
    doc.setFont("helvetica", "normal");
    doc.text(
      "Unit 706-19055 Airport Way, Pitt Meadows, BC. V3Y 0G4     P:604 461 4747     F:604 461 5747     info@maxilite.net",
      15,
      290
    );

    if (productPdfSku != null) {
      doc.save(`${productPdfSku}-Spec-Sheet.pdf`);
    } else {
      doc.save("Maxilite-Spec-Sheet.pdf");
    }
  } catch (e) {
    console.log(e);
  }
}

function getMetafieldData() {
  //Extracting Meafield Data:
 // console.log("Extracting Metafield Data:");
  const metafieldHTML = document.getElementById("maxi-metafield");
  if (!metafieldHTML) {
    console.error("Element 'maxi-metafield' not found");
    return null;
  }

  const metafieldText = metafieldHTML.textContent || metafieldHTML.innerHTML;
  const metafieldObject = JSON.parse(metafieldText);
  //console.log("Returning Meatafield data"); // This will log the parsed object to the console
  return metafieldObject;
}


function getFeaturedMedia() {
  const featuredMediaData = document.getElementById("testing_data_media");
 // console.log("Featured media: ", featuredMediaData);
  if (featuredMediaData) {
    const mediaId = featuredMediaData.getAttribute("data-media-id");

   // console.log("Media ID:", mediaId);
    return mediaId;
  } else {
  //  console.log("Element testing_data_media not found");
    return null;
  }
}

function getFeaturedImage() {
 // console.log("Getting Featured Image");

  const featuredImageHtml = document.getElementById(
    "featured-image-variant-data"
  );
  if (!featuredImageHtml) {
    console.error("Element 'featured-image-variant-data' not found");
    return { imageUrl: null, hasFeatureImage: null };
  }

  const featuredImageParagraph_one =
    featuredImageHtml.querySelector("p:first-of-type");
  const featuredImageParagraph_two =
    featuredImageHtml.querySelector("p:last-of-type");
  if (!featuredImageParagraph_one || !featuredImageParagraph_two) {
    console.error(
      "Failed to find the required paragraphs in 'featured-image-variant-data'"
    );
    return { imageUrl: null, hasFeatureImage: null };
  }

  const featuredImage_type =
    featuredImageParagraph_one.textContent ||
    featuredImageParagraph_one.innerHTML;
  const featuredImage_src =
    featuredImageParagraph_two.textContent ||
    featuredImageParagraph_two.innerHTML;

  if (
    featuredImage_type == "product.featured_image" ||
    featuredImage_type ==
      "product.selected_or_first_available_variant.featured_image"
  ) {
    const imageUrl = `https://cdn.shopify.com/s/files/1/0251/9964/0648/${featuredImage_src}`;
    const hasFeatureImage = true;
  //  console.log("Product has featured image");
   // console.log("type of featured image: ", featuredImage_type);
   // console.log(imageUrl);
    return { imageUrl, hasFeatureImage };
  } else {
    const imageUrl =
      "https://cdn.shopify.com/s/files/1/0251/9964/0648/files/spec-sheet-default-img.jpg";
    console.log("Not Product featured image");
    const hasFeatureImage = false;
    console.log(imageUrl);
    return { imageUrl, hasFeatureImage };
  }
}

function styleSpecsTable() {
  const showMore_Boton = document.getElementById("btn-prueba");
  const overlap_Contenedor = document.getElementById("sobreponer");
  const table_Contenedor = document.getElementById("tabla--div");
  const icons_Contenedor = document.getElementById("prueba--icon");

  const masRecursos = document.getElementsByClassName("mas-recursos");
  overlap_Contenedor.classList.add("cerrado");
  table_Contenedor.style.overflow = "hidden";
  table_Contenedor.classList.add("spects--cerrado");
  icons_Contenedor.classList.add("gg-chevron-down");

  function loaderHandler(){
    console.log("Loader Handler")
    const specs_loader = document.getElementById("loader_desc");
    const specs_table = document.getElementById("product-specs-table");

    if(specs_loader){
      console.log("Has SPEC loader");
      console.log(specs_loader.classList);
      if( !specs_loader.classList.contains('visually-hidden')){
        console.log(" Loader Is not hidden");
        specs_loader.classList.add('visually-hidden');
        specs_table.classList.remove('visually-hidden');
      }
      
    }
  
  }

  loaderHandler();

  function iconosToggleOpen() {
    icons_Contenedor.classList.remove("gg-chevron-up");
    icons_Contenedor.classList.add("gg-chevron-down");
  }

  function iconosToggleClose() {
    icons_Contenedor.classList.remove("gg-chevron-down");
    icons_Contenedor.classList.add("gg-chevron-up");
  }

  function click_abrir() {
    overlap_Contenedor.style.transform.translateY = "100px";
    overlap_Contenedor.style.transform.translateY = "100px";
    table_Contenedor.style.overflow = "visible";

    setTimeout(function () {
      overlap_Contenedor.classList.toggle("cerrado");
    }, 50);

    setTimeout(function () {
      table_Contenedor.classList.add("spects--cerrado");
    }, 90);

    iconosToggleOpen();
    showMore_Boton.textContent = "Show More";
    setTimeout(function () {
      table_Contenedor.style.overflow = "hidden";
    }, 90);
  }

  function click_cerrar() {
    overlap_Contenedor.style.transform.translateY = "-190px";

    setTimeout(function () {
      overlap_Contenedor.className = "abierto";
    }, 50);

    setTimeout(function () {
      table_Contenedor.classList.remove("spects--cerrado");
    }, 70);

    iconosToggleClose();
    showMore_Boton.textContent = "Show Less";
  }

  function newClickOpen(){
    $("#sobreponer").slideToggle(600, 'swing', function() {
      $("#tabla--div").removeClass("spects--cerrado");
      $(this).addClass("abierto");
      iconosToggleClose();
      showMore_Boton.textContent = "Show Less";
  });
  
  }

  function newClickClose(){
    $("#sobreponer").slideToggle(function(){
      $(this).addClass("abierto");
    });
  }

  showMore_Boton.addEventListener("click", function () {
    if (showMore_Boton.text === "Show Less") {
     click_abrir();
   // $("#sobreponer").slideToggle();
    // $("#tabla--div").slideToggle();
    } else if (showMore_Boton.text === "Show More") {
     click_cerrar();
    //  newClickOpen();
     // $("#tabla--div").slideToggle();
    }
  });

}

 async function getProductPageAttributes() {
    const productPageData = document.getElementById('product-page_data');
    
    if (!productPageData) {
        return {
            currentVariant: null,
            sectionId: null
        }
    }

    const currentVariant = productPageData.getAttribute("current-variant") || null;
    const sectionId = productPageData.getAttribute("section-id") || null;

    return {
        currentVariant: currentVariant,
        sectionId: sectionId
    };
}

function getSkuData() {
    const maxiliteSkuData = document.getElementById('maxi-product-sku');
    
    if (!maxiliteSkuData) {
        return null;
    }

    const skudata = maxiliteSkuData.textContent || maxiliteSkuData.innerHTML;
    const skuObject = JSON.parse(skudata);

    // If you want to log the value, you can uncomment the line below
    // console.log(skuObject);

    return skuObject;
}

function click_requestquote(){
  update_quoteform();
  $("#quoteform").slideToggle();

}



document.addEventListener('DOMContentLoaded', async (event) => {
    
    const { currentVariant, sectionId } = await getProductPageAttributes();
    console.log(sectionId);
    console.log(currentVariant);

    const skuData = await getSkuData();
    console.log(skuData);

    const cv_specs = await getMetafieldData();
    console.log(cv_specs);



    if(currentVariant && cv_specs){
        const blockSpecsTable = document.getElementById('spects--id');
        if(blockSpecsTable){
           assingSpecsData();
           styleSpecsTable();
           
        }

    }


    if (typeof window.subscribe === 'function') {
        const logVariantChangeMiddleware = async (event) => {
            console.log('variantChange event data MiddleWare:', event);
            // Accessing properties of the data object
            console.log('Variant:', event.data.variant);
            const blockAppVariant = event.data.variant.id;
            console.log('Event:', event);

            const html = event.data.html;
    
            console.log("New path: ");
            console.log(window.location.pathname);
            console.log(window.location.search);

            const blockSectionDiv = document.getElementById('product-page_data');
            if(blockSectionDiv){
                        const pageDataSource = html.getElementById("product-page_data");
                        const pageDataDestination = document.getElementById("product-page_data");
    
                        if(pageDataSource && pageDataDestination) {
                            pageDataDestination.innerHTML = pageDataSource.innerHTML;
                        }
                        const blockSpecsTable = document.getElementById('block_specsTable');
                        if(blockSpecsTable){
                            clearDataSpecsTable();
                            assingSpecsData();
                        }
            }
            


          };
          

          const unsubscribeMiddleware = window.subscribe('variant-change', logVariantChangeMiddleware);
          window.onbeforeunload = () => {
            console.log('unsubscribeMiddleware');
            unsubscribeMiddleware();
          };
    
    } else {
        console.error('window.subscribe is not available after DOMContentLoaded.');
    }
    

});



// custom inventory snippet controller